

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

const flattenCategoriesTree = (categories = []) => {
    const result = [];

    const traverse = (nodes) => {
        (nodes || []).forEach((node) => {
            result.push(node);
            const children = node.children || node.children_recursive || [];

            if (children.length > 0) {
                traverse(children);
            }
        });
    };

    traverse(categories);

    return result;
};

const getCategoryListFromResponse = (responseData) => {
    if (Array.isArray(responseData)) {
        return responseData;
    }

    return responseData?.categories || [];
};

const getCategoryDetailFromResponse = (responseData) => responseData?.category || responseData;

const getBranchListFromResponse = (responseData) => {
    if (Array.isArray(responseData)) {
        return responseData;
    }

    return responseData?.branches || [];
};

const annotateCategoryTreeWithParentTitle = (categories = [], parentTitle = null) =>
    categories.map((category) => ({
        ...category,
        parentTitleFa: parentTitle,
        children: annotateCategoryTreeWithParentTitle(
            category.children || category.children_recursive || [],
            category.title_fa
        ),
    }));

export { annotateCategoryTreeWithParentTitle, flattenCategoriesTree, getBase64, getBranchListFromResponse, getCategoryDetailFromResponse, getCategoryListFromResponse };
